/*
#Copyright 2025 Pixagan Technologies

# Licensed under the Apache License, Version 2.0 (the "License");
# you may not use this file except in compliance with the License.
# You may obtain a copy of the License at
#
#     http://www.apache.org/licenses/LICENSE-2.0
#
# Unless required by applicable law or agreed to in writing, software
# distributed under the License is distributed on an "AS IS" BASIS,
# WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
# See the License for the specific language governing permissions and
# limitations under the License.
*/

import React , { useState, useEffect, useCallback} from 'react'
import { Card, Badge, InputGroup, Button, Form, ListGroup, Row, Col} from 'react-bootstrap'
import { ArrowBigDown } from 'lucide-react'
import { Pencil, Check, CirclePlus } from 'lucide-react'

import axios from 'axios'

import { useSelector, useDispatch } from 'react-redux'

import { ReactFlow, Controls, Background, MiniMap, MarkerType } from '@xyflow/react';
import { applyEdgeChanges, applyNodeChanges } from '@xyflow/react';
import { addEdge } from '@xyflow/system';
import '@xyflow/react/dist/style.css';

import { DNode } from './DNode'
import { X } from 'lucide-react'


export const FlowViewData = ({currentFlow}) => {


    const dispatch = useDispatch()

    

    const [flowTitle, setFlowTitle] = useState("Flow i")
    const [selectedNode, setSelectedNode] = useState(null)
    const [viewSettings, setViewSettings] = useState(false)


    const nodeTypes = {
        cNode: DNode,
    };

   

    const initialEdges = [

      ];
       
      const initialNodes = [
        {
          id: 'INPUTS',
          name: 'INPUTS ',
          component: 'TextInput',
          data: { 
            label: 'INPUTS',
            action: 'INPUTS-FLOW',
            inputs: ['text'],
            outputs: ['text'],
          },
          type: 'cNode',
          position: { x: 0, y: 0 },
          inputs: ['text'],
          outputs: ['text'],
          code: 'print("Hello, World!")',
          state: 'idle',
          action: 'chatInput',
         
        },
        {
          id: 'OUTPUTS',
          name: 'OUTPUTS',
          component: 'TextInput',
          type: 'cNode',
          position: { x: 50, y: 50 },
          data: { 
            label: 'OUTPUTS',
            action: 'OUTPUTS-FLOW',
            inputs: ['text'],
            outputs: ['text'],
          },
         
        }
      ];
      

    const [nodes, setNodes] = useState(initialNodes);
    const [edges, setEdges] = useState(initialEdges);
    

   

    const onNodesChange = useCallback(
        (changes) => {
            //console.log('Node changes : ', changes)

          

            setNodes((nds) => applyNodeChanges(changes, nds))
            
        },
        [],
      );

     

    const onEdgesChange = useCallback(
        (changes) => {
            //console.log('Edge changes : ', changes)
           

            setEdges((eds) => applyEdgeChanges(changes, eds))
        },
        [],
    );




    const onNodeClick = (event, node) => {
        console.log('click node', node);
        
        //setViewSettings(viewSettings=> !viewSettings)

    }

    const onNodeDoubleClick = (event, node) => {
        console.log('double click node', node);
        // setSelectedNode(node)
        // setViewSettings(true)

    }


    const addEdgeRequest = (connection) => {
        const newEdge = {
            id: connection.id || `edge-${Date.now()}`,
            source: connection.source,
            sourceHandle: connection.sourceHandle,
            target: connection.target,
            targetHandle: connection.targetHandle,
            label: `${connection.source}-${connection.target}`,
            markerEnd: {
                type: MarkerType.ArrowClosed,
                width: 20,
                height: 20,
                color: '#FF0072',
            },
            style: {
                strokeWidth: 2,
                stroke: '#FF0072',
            }
        };
        
        setEdges((eds) => addEdge(newEdge, eds));
        
    }
    const loadEdges = (edges) => {
        console.log("Loading edges from backend:", edges);
        
        const formattedEdges = edges.map(edge => ({
            id: edge.id,
            source: edge.source,
            sourceHandle: edge.sourceHandle,
            target: edge.target,
            targetHandle: edge.targetHandle,
            label: edge.label,
            markerEnd: {
                type: MarkerType.ArrowClosed,
                width: 20,
                height: 20,
                color: '#FF0072',
            },
            style: {
                strokeWidth: 2,
                stroke: '#FF0072',
            }
        }));
        
        setEdges(formattedEdges);
    };


    useEffect(() => {

        if(currentFlow != null){
            if (currentFlow.nodes){

                //check if a start and END NOde are already there
                // const startNode = currentFlow.nodes.find(node => node.id === 'Inputs')
                // const endNode   = currentFlow.nodes.find(node => node.id === 'Outputs')
                // if(!startNode){
                //     currentFlow.nodes.push({
                //         id: 'Inputs',
                //         name: 'INPUTS',
                //         data: { 
                //           label: 'INPUTS',
                //           action: 'INPUTS-FLOW',
                //           inputs: [],
                //           outputs: ['input1'],
                //         },
                //         type: 'cNode',
                //         position: { x: 0, y: 0 },
                //         inputs: [],
                //         outputs: ['input1'],
                //         code: 'print("Hello, World!")',
                //         state: 'idle',
                //         action: 'chatInput',
                        
                //       })
                // }
                // if(!endNode){
                //     currentFlow.nodes.push( {
                //         id: 'Outputs',
                //         name: 'OUTPUTS',
                //         inputs: ['output1'],
                //         outputs: [],
                //         type: 'cNode',
                //         position: { x: 50, y: 50 },
                //         data: { 
                //           label: 'Outputs',
                //           action: 'END-FLOW',
                //           inputs: ['output1'],
                //           outputs: [],
                //         },
                       
                //       })
                // }
                setNodes(currentFlow.nodes)
            }
            if(currentFlow.datasources){
            //setEdges(currentFlow.edges)
                loadEdges(currentFlow.datasources)
            }
        }

    }, [currentFlow])

   
 


    return (

        <div>
          
  
         

            <Row>

         

                <Col >

                <div style={{ width: '100%', height: '100vh', position: 'relative' , borderWidth:'1px'}}>
                <ReactFlow nodes={nodes}
                onNodesChange={onNodesChange}
                edges={edges}
                onEdgesChange={onEdgesChange}
                onConnect={addEdgeRequest}
                onNodeClick={onNodeClick}
                onNodeDoubleClick={onNodeDoubleClick}
                nodeTypes={nodeTypes}
                style={{
                    width: '100%',
                    height: '100%',
                    background: '#fff'
                    
                }}
                fitView  
                >
                    {/* <MiniMap /> */}
                    <Background />
                    <Controls />
                </ReactFlow>
            </div>
                    
                
                </Col>

                {/* {selectedNode && (
                    <Col style={{maxWidth:'40vw', border:'solid', borderWidth:'1px'}}>
                        
                    
                        <Button  style={{paddingTop:'2px', paddingBottom:'2px', backgroundColor:'blue', color:'white', backgroundColor:'red', alignSelf:'right'}} onClick={()=>setSelectedNode(null)}><X /></Button>
                        

                        <NodeViewBasic currentNode={selectedNode}/>
                
                     </Col>
                )} */}

            </Row>

         
        
        </div>

    )
}


export default FlowViewData
